// extracted by mini-css-extract-plugin
export default {"gameLevel":"Level_gameLevel__R6Bdk","wrapper":"Level_wrapper__j8MpS","gameOver":"Level_gameOver__hjSPu","gameActive":"Level_gameActive__7QvB1"};